/** The few inline icons of the page. The Stippl mark is the `#atp-smark` sprite symbol rendered once by the page. */

export const S_PATH =
	"M17.3912 99.1864C14.9217 99.1864 12.9613 101.159 13.0092 103.593C13.0589 106.025 15.0991 108 17.5668 108C20.0363 108 21.9967 106.025 21.9488 103.593C21.8991 101.159 19.8589 99.1864 17.3912 99.1864ZM65.3336 33.3614C76.1235 30.4927 80.4221 24.1043 80.431 16.7419C80.4434 6.75566 72.3519 0 59.0871 0C38.1939 0 0 22.4846 0 43.1187C0 59.3036 21.0387 64.5548 35.3004 67.8972C49.5639 71.2377 60.588 74.2732 60.588 78.2187C60.588 82.1625 48.0081 91.0523 27.7464 97.4815C25.575 98.2036 24.3065 100.144 24.9097 101.816C25.5147 103.487 27.7145 104.079 29.9356 103.533C38.3749 101.452 78.201 92.3474 78.201 74.4204C78.201 56.4935 35.2862 49.1612 35.2862 45.9005C35.2862 42.5528 56.6017 35.6819 65.3336 33.3614Z";

/** Hidden sprite with the Stippl mark, rendered once at the top of the page. */
export const SMarkSprite = () => (
	<svg width="0" height="0" style={{ position: "absolute" }} aria-hidden="true">
		<defs>
			<symbol id="atp-smark" viewBox="0 0 81 108">
				<path d={S_PATH} />
			</symbol>
		</defs>
	</svg>
);

/** A photo cut into the tilted Stippl S, floating behind a section. */
export const SPhoto = ({ clipId, photo, className }: { clipId: string; photo: string; className: string }) => (
	<div className={`s-flow ${className}`} aria-hidden="true">
		<svg width="100%" height="100%" viewBox="-3.3 -3.9 87 116" preserveAspectRatio="xMidYMid meet">
			<defs>
				<clipPath id={clipId}>
					<path d={S_PATH} transform="rotate(-14 40.5 54)" />
				</clipPath>
			</defs>
			<g clipPath={`url(#${clipId})`}>
				<image href={photo} x="-3.3" y="-3.9" width="87" height="116" preserveAspectRatio="xMidYMid slice" />
			</g>
		</svg>
	</div>
);

export const SMark = ({ fill = "currentColor" }: { fill?: string }) => (
	<svg viewBox="0 0 81 108" fill={fill} aria-hidden="true">
		<use href="#atp-smark" />
	</svg>
);

/** Diagonal arrow on every "opens the assistant" button. */
export const ExternalArrow = () => (
	<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
		<path d="M7 17L17 7M9 7h8v8" />
	</svg>
);

export const Tick = ({ stroke = "#fff", width = 3 }: { stroke?: string; width?: number }) => (
	<svg viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth={width} strokeLinecap="round" strokeLinejoin="round">
		<path d="M5 12l5 5 9-10" />
	</svg>
);

export const SendArrow = () => (
	<svg viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round">
		<path d="M12 19V5M5 12l7-7 7 7" />
	</svg>
);

export const CLAUDE_MARK_PATH = "M12 2l1.6 6.4L20 7l-4.8 4.6L22 12l-6.8 1.4L20 17l-6.4-1.4L12 22l-1.6-6.4L4 17l4.8-3.6L2 12l6.8-.4L4 7l6.4 1.4z";

/** Claude's neutral spark (not Anthropic's logo). */
export const ClaudeMark = () => (
	<svg className="claude-mark" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
		<path fill="#d97757" d={CLAUDE_MARK_PATH} />
	</svg>
);
